import { render, staticRenderFns } from "./roleDialog.vue?vue&type=template&id=64fb9b96"
import script from "./roleDialog.vue?vue&type=script&lang=js"
export * from "./roleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports